import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import { closeModal, FORM_PATHS } from '../../../actions/modals';
import { AppModalHeader } from '../../common/AppModalHeader';
import CompleteMeetingForm from '../Forms/CompleteMeetingForm';

class CompleteMeetingModal extends React.Component {
    render() {
        const { modals, setModalClosed } = this.props;

        return modals.CompleteMeetingModal.isOpen ? (
            <Modal className={this.props.className} isOpen toggle={() => setModalClosed()}>
                <AppModalHeader toggle={() => setModalClosed()}>Complete Meeting</AppModalHeader>
                <ModalBody>
                    <CompleteMeetingForm
                        companyId={modals.CompleteMeetingModal.data.companyId}
                        meetingId={modals.CompleteMeetingModal.data.meetingId}
                        onCancel={() => setModalClosed()}
                    />
                </ModalBody>
            </Modal>
        ) : (
            ''
        );
    }
}

const mapStateToProps = state => ({
    modals: state.modals
});

const mapDispatchToProps = dispatch => ({
    setModalClosed: () => dispatch(closeModal(FORM_PATHS.CompleteMeetingModal.modalName))
});

export default connect(mapStateToProps, mapDispatchToProps)(CompleteMeetingModal);
